import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generatePath, useLocation, useNavigate } from "react-router";

import {
    adminPath,
    loginConstants,
    paramsConstants,
    pathConstant,
    NAVIGATION_DELAYS_MS,
    userPermissionsConstants,
} from "../../../views/shared-screens/constants";
import { setItemToStorage } from "../../../system";
import { handleAsyncAction } from "../../../shared/utils/handleAsyncAction";
import {
    brandProfileActions,
    individualStoreProfileActions,
} from "../../../views/shared-screens/redux/actions";

const { SUPER_ADMIN } = userPermissionsConstants;
const { ROLE, BRAND_ID, LOCATION_ID } = loginConstants;

const RouteFromFR = (props) => {
    const { getProfileData, getBrandProfile } = props;

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const locationId = params.get(paramsConstants.LOCATION_ID);

    // Load the store after the redirect screen has been shown.
    useEffect(() => {
        if (!locationId) {
            return;
        }

        const timeoutId = setTimeout(() => {
            handleAsyncAction(getProfileData(locationId, true), {
                onSuccess: (response) => {
                    const { id, brandId } = response;

                    // Load the brand name for the dashboard.
                    getBrandProfile(brandId);

                    // Keep the account and store details for the next screen.
                    setItemToStorage(ROLE, SUPER_ADMIN);
                    setItemToStorage(LOCATION_ID, id);
                    setItemToStorage(BRAND_ID, brandId);

                    navigate(
                        generatePath(adminPath.RESTAURANTS_RESTAURANT_PROFILE, {
                            brandId: String(brandId),
                            locationId: String(id),
                        }),
                        {
                            state: { name: pathConstant.STORES },
                            replace: true,
                        }
                    );
                },
            });
        }, NAVIGATION_DELAYS_MS.FR_STORE_PROFILE_REQUEST);

        // Cancel the pending request when this screen is no longer shown.
        return () => clearTimeout(timeoutId);
    }, [locationId, getProfileData, getBrandProfile, navigate]);

    return (
        <div className="w-100 vh-100 d-flex justify-content-center align-items-center">
            <div className="bg-secondary bg-opacity-10 rounded-4 p-5">
                <h5 className="fw-bold">Redirecting....</h5>
                <p className="pt-3">
                    Just a sec! We're getting things ready for you.
                    <br /> You'll be on the
                    <strong> Survey Profile</strong> page shortly.
                </p>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    individualStoreProfileReducer: state.individualStoreProfileReducer,
});

const mapDispatchToProps = (dispatch) => ({
    getProfileData: (id, frRoute) =>
        dispatch(
            individualStoreProfileActions.getStoreProfileData(id, frRoute)
        ),
    getBrandProfile: (id) => dispatch(brandProfileActions.getBrandProfile(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteFromFR);
